var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarDropdownArrow = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.55746 14.1925L3.30746 7.94253C3.2494 7.88447 3.20333 7.81553 3.17191 7.73966C3.14048 7.66379 3.1243 7.58247 3.1243 7.50035C3.1243 7.41823 3.14048 7.33691 3.17191 7.26104C3.20333 7.18517 3.2494 7.11623 3.30746 7.05816C3.36553 7.00009 3.43447 6.95403 3.51034 6.9226C3.58621 6.89117 3.66753 6.875 3.74965 6.875C3.83177 6.875 3.91309 6.89117 3.98896 6.9226C4.06483 6.95403 4.13377 7.00009 4.19184 7.05816L9.99965 12.8668L15.8075 7.05816C15.9247 6.94088 16.0838 6.875 16.2497 6.875C16.4155 6.875 16.5746 6.94088 16.6918 7.05816C16.8091 7.17544 16.875 7.3345 16.875 7.50035C16.875 7.6662 16.8091 7.82526 16.6918 7.94254L10.4418 14.1925C10.3838 14.2506 10.3149 14.2967 10.239 14.3282C10.1631 14.3597 10.0818 14.3758 9.99965 14.3758C9.91752 14.3758 9.83619 14.3597 9.76031 14.3282C9.68444 14.2967 9.61551 14.2506 9.55746 14.1925Z",
  fill: "#7A757F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarDropdownArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_dropdown_arrow.f3b95e35a39d3fcbcf9818fd9f7a8d6c.svg";